export const PAGAMENTO_CON_PUNTI = {
  DISATTIVO: 'disattivo',
  ATTIVO: 'attivo',
  SOLO_PUNTI: 'solo_punti',
};

export const normalizePagamentoConPunti = (value) => {
  if (value === true) return PAGAMENTO_CON_PUNTI.ATTIVO;
  if (value === false || value == null || value === '') {
    return PAGAMENTO_CON_PUNTI.DISATTIVO;
  }
  const str = String(value);
  if (Object.values(PAGAMENTO_CON_PUNTI).includes(str)) return str;
  return PAGAMENTO_CON_PUNTI.DISATTIVO;
};

export const getPagamentoConPuntiMode = (event) =>
  normalizePagamentoConPunti(event?.pagamentoConPunti);

export const eventAllowsPuntiPayment = (event) => {
  const mode = getPagamentoConPuntiMode(event);
  return (
    mode === PAGAMENTO_CON_PUNTI.ATTIVO ||
    mode === PAGAMENTO_CON_PUNTI.SOLO_PUNTI
  );
};

export const eventRequiresSoloPuntiPayment = (event) =>
  getPagamentoConPuntiMode(event) === PAGAMENTO_CON_PUNTI.SOLO_PUNTI;

export const eventAllowsPublicNonPuntiPayment = (event) =>
  !eventRequiresSoloPuntiPayment(event);
